import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import React, { Children, ReactNode, useContext, useState } from 'react';
import { Button } from '@mui/material';
import SidebarMenu from '../SidebarMenu';
import logger from '../../utils/logger';
import { MenuData } from 'app/constants/types';

interface Props {
  children: ReactNode;
  setOpen: (st: boolean) => void;
  open: boolean;
  hide?: boolean;
  menu?: MenuData[];
}
const DrawerCustom = (props: Props) => {
  const { children, open, setOpen, hide, menu } = props;

  logger.log('State', menu);

  return (
    <>
      {hide ? (
        <SwipeableDrawer
          sx={{ '& .MuiDrawer-paper': { width: '100%' } }}
          anchor={'left'}
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
        >
          {children}
          <SidebarMenu menu={menu} setOpen={setOpen} />
        </SwipeableDrawer>
      ) : (
        children
      )}
    </>
  );
};

export default DrawerCustom;
